import { all } from 'redux-saga/effects';
import searchSagas from '../../../../../shared/frontend/scripts/global-search/store/sagas';
import autoCompleteSagas from '../../../../../shared/frontend/scripts/global-search/autocomplete/store/sagas';
import { sagas as groupCharterSagas } from '../../../../../shared/frontend/scripts/actions/groupCharter';
import { sagas as userSagas } from '../user/modules';
import { sagas as messageCenterSagas } from '../messageCenter/modules';
import { sagas as threadSagas } from '../thread/modules';
import recruitmentProfileCreationSagas from '../recruitmentProfiles/sagas';
import recruitmentSettingsSagas from '../recruitmentSettings/sagas';
import characterRecruitmentPageSagas from '../character/sagas';
import guildRecruitmentPageSagas from '../guild/sagas';
import localRecruitmentProfileSagas from '../shared/recruitment/components/RecruitmentProfilePreview/sagas';
import sharedRecruitmentSagas from '../shared/recruitment/sagas';

export default function* rootSaga(): any {
  yield all([
    ...searchSagas,
    ...autoCompleteSagas,
    ...userSagas,
    ...groupCharterSagas,
    ...messageCenterSagas,
    ...threadSagas,
    ...recruitmentProfileCreationSagas,
    ...recruitmentSettingsSagas,
    ...characterRecruitmentPageSagas,
    ...guildRecruitmentPageSagas,
    ...localRecruitmentProfileSagas,
    ...sharedRecruitmentSagas
  ]);
}
